import React from "react";
import { Grid, Container, Box, Icon } from '@mui/material';
import { Slide } from "react-awesome-reveal";

const Team = ({data , parseContent}) => {
  const { cards }  = data || [];
  return (
    <div id="Team" className="text-center">
      <Container className="container" >
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>{data ? data.title : "...loading"}</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit duis sed
            dapibus leonec.
          </p>
        </div>
        <Slide cascade damping={0.3}>
          <Grid  container className="portfolio-items row" spacing={{xs:.5, lg : 2}}>
            {cards?.length
              ? cards.map((d, i) => (
                  <Grid key={`${d.title}-${i}`} item md={3} xs={6}>
                    <div className="thumbnail">
                      {" "}
                      <Box component="img" sx={{maxWidth:"100%"}} src={`${process.env.REACT_APP_PUBLIC_URL}/img/team/${d.img}`} alt="..." className="team-img" />
                      <div className="caption">
                        <h4>{d.title}</h4>
                        <Box style={{ textAlign:"center"}}>{parseContent(d.text.substring(0,150))}</Box>
                      </div>
                    </div>
                  </Grid>
              ))
            : "loading"}
          </Grid>
        </Slide>
      </Container>
    </div>
  );
};

export default Team